// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IntegrationsOverview_wrapper__C89sz","iconWrapper":"IntegrationsOverview_iconWrapper__IqxG6","icon":"IntegrationsOverview_icon__LjR4X"};